import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

import { InitializableQuizApiModel } from '@app/api/api-models/dashboard/InitializableQuizApiModel';
import { FormActionListApiModel } from '@app/api/api-models/dashboard/FormActionListApiModel';
import { ReportsOverviewApiModel } from '@app/api/api-models/dashboard/ReportsOverviewApiModel';
import { ProgramRoleApiModel } from '@app/api/api-models/dashboard/ProgramRoleApiModel';
import { DashboardAlertApiModel } from '@app/api/api-models/dashboard/DashboardAlertApiModel';
import { DashboardSearchResultApiModel } from '@app/api/api-models/dashboard/DashboardSearchResultApiModel';
import { DashboardHeaderApiModel } from '@app/api/api-models/dashboard/DashboardHeaderApiModel';
import { RecallScoreApiModel } from '@app/api/api-models/dashboard/RecallScoreApiModel';
import { InitializedQuizApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class DashboardService {
  public apiUrl = 'ft-dashboard';
  public apiSearchUrl = 'search';

  constructor(private readonly http: HttpClientService) {}

  public getHeaderInfo(programRoleId: string): Observable<DashboardHeaderApiModel> {
    return this.http.get<DashboardHeaderApiModel>(`${this.apiUrl}/${programRoleId}/header-info`);
  }

  public getAvailableForms(programRoleId: string): Observable<Array<FormActionListApiModel>> {
    return this.http.get<Array<FormActionListApiModel>>(`${this.apiUrl}/${programRoleId}/available-forms`);
  }

  public getInitializedQuizzes(programRoleId: string): Observable<Array<InitializedQuizApiModel>> {
    return this.http.get<Array<InitializedQuizApiModel>>(`${this.apiUrl}/${programRoleId}/initialized-quizzes`);
  }

  public getInstances(programRoleId: string): Observable<Array<DashboardSearchResultApiModel>> {
    return this.http.get<Array<DashboardSearchResultApiModel>>(
      `${this.apiSearchUrl}/${programRoleId}/trainee-form-instances`
    );
  }

  public getReportsOverview(programRoleId: string, phaseId?: number): Observable<ReportsOverviewApiModel> {
    return this.http.get<ReportsOverviewApiModel>(`${this.apiUrl}/${programRoleId}/reports-overview`, {
      params: {
        phaseId: phaseId ? phaseId.toString() : ''
      }
    });
  }

  public getInitializableQuizzes(programRoleId: string): Observable<Array<InitializableQuizApiModel>> {
    return this.http.get<Array<InitializableQuizApiModel>>(`${this.apiUrl}/${programRoleId}/initializable-quizzes`);
  }

  public getRelatedSubjects(formId: number): Observable<Array<ProgramRoleApiModel>> {
    return this.http.get<Array<ProgramRoleApiModel>>(`${this.apiUrl}/related-subjects`, {
      params: {
        formId: formId.toString()
      }
    });
  }

  public getAlerts(programRoleId: string): Observable<Array<DashboardAlertApiModel>> {
    return this.http.get<Array<DashboardAlertApiModel>>(`${this.apiUrl}/${programRoleId}/alerts`);
  }

  public getRecallScores(programRoleId: string, eidToken: string): Observable<RecallScoreApiModel> {
    const options = {
      headers: new HttpHeaders({
        'X-Eid-Token': eidToken
      })
    };
    return this.http.get<RecallScoreApiModel>(`recall-scores/${programRoleId}`, options);
  }
}
